import React from 'react';
import { Add, Delete, Edit, PersonAdd, PersonRemove } from '@mui/icons-material';

import { BaseStatusChip } from '../../Paylinks/components/StatusChip';
import type { AuditLogAction, AuditLogResource } from '../../../store/modules/merchant/types';
import { colorError, colorSuccess, colorWarning, StatusColor } from '../../../util/constants';

const actionUiMap: Record<
  AuditLogAction,
  { icon: JSX.Element; color: StatusColor; label: string }
> = {
  create: { icon: <Add />, color: colorSuccess, label: 'Create' },
  update: { icon: <Edit />, color: colorWarning, label: 'Edit' },
  delete: { icon: <Delete />, color: colorError, label: 'Delete' },
};

const portalUserAccessActionUiMap: Partial<
  Record<AuditLogAction, { icon: JSX.Element; color: StatusColor; label: string }>
> = {
  create: { icon: <PersonAdd />, color: colorSuccess, label: 'Grant access' },
  delete: { icon: <PersonRemove />, color: colorError, label: 'Revoke access' },
};

type Props = {
  action: AuditLogAction;
  resource?: AuditLogResource;
  size?: 'small' | 'medium';
};

export const AuditLogActionChip = ({ action, resource, size = 'small' }: Props): JSX.Element => {
  const actionUi =
    (resource === 'portalUserAccess' ? portalUserAccessActionUiMap[action] : undefined) ??
    actionUiMap[action];

  return (
    <BaseStatusChip
      color={actionUi.color}
      icon={actionUi.icon}
      label={actionUi.label}
      size={size}
    />
  );
};
